/**
 * バリデーションチェック
 */
export const validationMixin = {
  methods: {
    /**
     * バリデーションチェック
     */
    $_validate() {
      const form = this.$refs.form;
      if (!form.validate()) {
        // 最初のエラー箇所へスクロール
        const firstError = form.inputs.find((input) => input.hasError);
        this.$vuetify.goTo(firstError, { offset: 100 });
        return false;
      }
      return true;
    },
  },
};
